import Courses from './Courses/Courses';
import Desginations from './DesignationsAndSkills/Desginations';
import Skills from './DesignationsAndSkills/Skills';
import HolidaysComponent from './Holidays/HolidaysComponent';
import LeaveTypes from './LeaveTypes/LeaveTypes';
import LeaveGroups from './LeaveGroups/LeaveGroups';
import OfficeLocation from './OfficeLocation/OfficeLocation';
import MoodleConfig from './Config/MoodleConfig';
export const MasterdataTabs = [
  {
    title: 'Holidays',
    index: 0,
    component: <HolidaysComponent />,
  },
  {
    title: 'Leave Types',
    index: 1,
    component: <LeaveTypes />,
  },
  {
    title: 'Leave Groups',
    index: 2,
    component: <LeaveGroups />,
  },
  {
    title: 'Designations',
    index: 3,
    component: <Desginations />,
  },
  {
    title: 'Skills',
    index: 4,
    component: <Skills />,
  },
  {
    title: 'Office Location',
    index: 5,
    component: <OfficeLocation />,
  },
  {
    title: 'Courses',
    index: 6,
    component: <Courses />,
  },
  {
    title: 'Config',
    index: 7,
    component: <MoodleConfig />,
  },
];
